import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const YEAR_END_BANQUET_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./year-end-banquet-home/year-end-banquet-home.component').then(m => m.YearEndBanquetHomeComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'registration',
    loadComponent: () => import('./banquet-registration/banquet-registration.component').then(m => m.BanquetRegistrationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'registration/:year',
    loadComponent: () => import('./banquet-registration/banquet-registration.component').then(m => m.BanquetRegistrationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'statistics',
    loadComponent: () => import('./banquet-statistics/banquet-statistics.component').then(m => m.BanquetStatisticsComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'statistics/:year',
    loadComponent: () => import('./banquet-statistics/banquet-statistics.component').then(m => m.BanquetStatisticsComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'lucky_draw',
    loadComponent: () => import('./lucky-draw/lucky-draw.component').then(m => m.LuckyDrawComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'receiver',
    loadComponent: () => import('./banquet-check-in-receiver/banquet-check-in-receiver.component').then(m => m.BanquetCheckInReceiverComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'config-admin',
    loadComponent: () => import('./banquet-config-admin/banquet-config-admin.component').then(m => m.BanquetConfigAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'shuttle-routes',
    loadComponent: () => import('./banquet-shuttle-routes-manage/banquet-shuttle-routes-manage.component').then(m => m.BanquetShuttleRoutesManageComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'shuttle-routes/:year',
    loadComponent: () => import('./banquet-shuttle-routes-manage/banquet-shuttle-routes-manage.component').then(m => m.BanquetShuttleRoutesManageComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'seating',
    loadComponent: () => import('./banquet-seating/banquet-seating.component').then(m => m.BanquetSeatingComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'seating/:year',
    loadComponent: () => import('./banquet-seating/banquet-seating.component').then(m => m.BanquetSeatingComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  }
];
